angular
    .module('userNotifications.v1')
    .directive('pendingReviewList', pendingReviewList)
    .directive('pendingReviewListItemWrapper', pendingReviewListItemWrapper)
    .directive('pendingReviewListItem', pendingReviewListItem);

/**
 * @ngdoc directive
 * @name userNotifications.v1.directive:pendingReviewList
 * @restrict A
 * @element any
 *
 * @description
 * Displays a list of all jobs marked as "pending review," and exposes notification
 * data to the theme markup.
 *
 * **Requirements:** A `pending-review-list-item` element must be a child of this element. See example.
 *
 * #### Data
 * - `{{orderNumber}}` : the order number each notification is associated with
 * - `{{jobNumber}}` : the job number each notification is associated with
 * - `{{jobName}}` : the name of the associated job
 * - `{{jobHref}}` : the href of the associated job
 * - `{{productName}}` : the product name of the associated job
 *
 * #### Script file
 * - `/web3/build/storefront/widgets/pending-review-list.v1.directive.js`
 *
 * #### Classes
 * - `isPending` : applied while notifications are in the proces of loading
 * - `isEmpty` : applied when there are 0 notifications in the list
 *
 * #### Events
 * - `window.events.PENDING_REVIEW_LIST_UPDATED` : raised whenever the notification list changes
 *
 * @example
    <pre>
        <!-- load widget script -->
        <script src="/web3/build/storefront/widgets/pending-review-list.v1.directive.js"></script>

        <!-- display widget -->
        <div pending-review-list>
            <div pending-review-list-item>
                <p>Order Number: {{orderNumber}}</p>
                <p>Job Number: {{jobNumber}}</p>
                <p>Job Name: {{jobName}}</p>
                <p>Job Link: {{jobHref}}</p>
                <p>Product Name: {{productName}}</p>
            </div>
        </div>

        <!-- respond to events -->
        <script>
            window.events.listen(window.events.PENDING_REVIEW_LIST_UPDATED, function () {
                console.log('pending review list updated');
            });
        </script>
    </pre>
    *
    * #### Output markup:
    * - This directive adds an unordered list between the `pending-review-list` element and the
    * `pending-review-list-item` elements.
    *
    * ```
    *       <div pending-review-list>
    *           <ul class="notificationList notificationList_pendingReview">
    *               <li class="notificationList-item">
    *                   <div pending-review-list-item>
    *                       ...
    *                   </div>
    *               </li>
    *               ...
    *           </ul
    *       </div>
    * ```
    *
    */

pendingReviewList.$inject = [];

function pendingReviewList () {
    return {
        restrict: 'A',
        transclude: true,
        template: '<ul class="notificationList notificationList_pendingReview"><li class="notificationList-item" ng-repeat="notification in pendingReviewListController.notifications"><div pending-review-list-item-wrapper="notification" class="notificationList-item-wrapper"><ng-transclude /></div></li></ul>',
        link: function pendingReviewListDirective_linkFn (scope, element, attrs, controller, transclude) {},
        controller: PendingReviewListController,
        controllerAs: 'pendingReviewListController',
        bindToController: true,
        scope: {}
    };
};

PendingReviewListController.$inject = ['$scope', '$element', 'userNotificationsService', 'authService', '$timeout'];

function PendingReviewListController ($scope, $element, userNotificationsService, authService, $timeout) {
    var vm = this;

    vm.notifications = [];

    init();

    return;

    function init () {
        $element
            .addClass('isEmpty')
            .addClass('isPending');
        // Subscribe to auth changes
        authService.subscribe($scope, handleAuthChange);
        // Subscribe to pendingReviewItems updates
        userNotificationsService.pendingReviewItems.subscribe($scope, handlePendingReviewItemsUpdate);
        // Subscribe to classic events
        userNotificationsService.classicEvents.subscribe($scope, getPendingReviewItems);
        // Initial loading of pendingReviewItems
        getPendingReviewItems();
    }

    function handleAuthChange ($event, user) {
        if (!authService.isLoggedIn()) {
            return resetDirective();
        }

        getPendingReviewItems();
    }

    function getPendingReviewItems () {
        if (!authService.isLoggedIn()) {
            return resetDirective();
        }

        userNotificationsService.pendingReviewItems.get(authService.getUser().id);
    }

    function handlePendingReviewItemsUpdate ($event, notifications) {
        if (!notifications) {
            return resetDirective();
        }

        if (!notifications.length) {
            $element.addClass('isEmpty');
        } else {
            $element.removeClass('isEmpty');
        }

        $timeout(function(){
            vm.notifications = notifications;
        });
        $element
            .show()
            .removeClass('isPending');
    }

    function resetDirective () {
        vm.notifications = [];
        $element
            .hide()
            .addClass('isEmpty')
            .removeClass('isPending');
    }
};


pendingReviewListItemWrapper.$inject = [];

function pendingReviewListItemWrapper () {
    return {
        restrict: 'A',
        transclude: true,
        template: '<ng-transclude />',
        link: function pendingReviewListItemWrapperDirective_linkFn (scope, element, attrs, controller, transclude) {},
        controller: PendingReviewListItemWrapperController,
        controllerAs: 'pendingReviewListItemWrapperController',
        bindToController: true,
        scope: {
            notification: '<pendingReviewListItemWrapper'
        }
    };
};

PendingReviewListItemWrapperController.$inject = [];

function PendingReviewListItemWrapperController () {};


pendingReviewListItem.$inject = [];

function pendingReviewListItem () {
    return {
        restrict: 'A',
        require: '^pendingReviewListItemWrapper',
        transclude: true,
        template: '<a href="{{jobHref}}" rel="nofollow"><p class="order-number">Order #<span>{{orderNumber}}</span></p><p class="item-number">Item #<span>{{jobNumber}}</span></p><p class="item-name">{{jobName}}</p></a>',
        link: function pendingReviewItemDirective_linkFn (scope, element, attrs, pendingReviewListItemWrapperController, transclude) {
            scope.orderNumber = pendingReviewListItemWrapperController.notification.orderNumber;
            scope.jobNumber = pendingReviewListItemWrapperController.notification.jobNumber;
            scope.jobName = pendingReviewListItemWrapperController.notification.jobName;
            scope.jobHref = pendingReviewListItemWrapperController.notification.jobStorefrontLink;
            scope.productName = pendingReviewListItemWrapperController.notification.productName;
        }
    };
};